module.exports = __webpack_public_path__ + "assets/webgl/wp_concrete_01b2_color.58337504.jpg";